<div [class.hide-additional-fields]="!showAdditionalFields"
  class="main-container" [class.collapsed]="computedIsCollapsed$ | async"
  [attr.data-is-collapsed]="computedIsCollapsed$ | async"
  [class.is-hidden]="!(computedIsVisible$ | async)"
  [class.expanded]="!(computedIsCollapsed$ | async)" [attr.data-label]="title" [class.has-border]="showBorder">

  <!-- Header -->
  <div class="header-container header-container-collapsible" [class.hide-header]="!showHeader">
    <span (click)="toggleIsCollapsedAsync()"
      class="header-toggle">
      <span class="caption-text" role="heading">{{title}}</span></span>
      @if (promotedFields.length) {
        <span class="importance-promoted-container">
          @for (pvm of promotedFieldsFiltered; track pvm) {
            <div
              popper="{{pvm.metadataDescription}}"
              [popperTrigger]="ngxPopperjsTriggers.hover"
              [popperDelay]="1000"
              popperApplyClass="info"
              [popperPlacement]="ngxPopperjsPlacements.TOP"
              [popperPreventOverflow]="false"
              [popperHideOnScroll]="true"
              popperAppendTo="body"
              [attr.data-referencecontrolid]="pvm.uniqueId"
              class="importance-promoted">
              {{ pvm.formattedValue}}
            </div>
          }
        </span>
      }
      <div class="header-spacing"></div>

      <div class="header-commands">
        @for (cmd of defaultCommands.concat(commands); track cmd) {
          @if (cmd.isVisible$ | async) {
            <nts-text-button
              class="action-toggle"
              [isDisabled]="!(cmd.canExecute$ | async)"
              [title]="cmd.tooltip$ | async"
              [label]="cmd.displayName$ | async"
              [isLoading]="cmd.loading$ | async"
              [icon]="cmd.iconClass$ | async"
              (onClicked)="cmd.execute()">
            </nts-text-button>
          }
        }
      </div>

    </div>

    <!-- Content -->
    <div class="collapsible-tab" [class.hide-header]="!showHeader">
      <div class="multiple-columns-group">
        <ng-content></ng-content>
      </div>
    </div>
  </div>